import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Profile from '@/popup/components/views/Home/Profile/Profile.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Profile))
}
}

})